import { render } from "./TrashcanModal.vue?vue&type=template&id=4610c63e"
import script from "./TrashcanModal.vue?vue&type=script&lang=js"
export * from "./TrashcanModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/treim/code/casp/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__